import React from 'react';
import { TEMPOS, ENERGY_LEVELS, DANCEABILITY_LEVELS, ACOUSTICNESS_LEVELS, VOCAL_STYLES } from '../data/constants';
import './CustomRules.css';

export default function CustomRules({ rules, onRulesChange }) {
  const updateRule = (key, value) => {
    onRulesChange({ ...rules, [key]: value });
  };

  return (
    <div className="custom-rules">
      <h3>⚙️ 自定义规则（高级）</h3>
      <div className="rules-grid">
        <div className="rule-group">
          <label>节奏</label>
          <div className="rule-options">
            {TEMPOS.map(t => (
              <button
                key={t.id}
                className={`rule-btn ${rules.tempo === t.id ? 'active' : ''}`}
                onClick={() => updateRule('tempo', rules.tempo === t.id ? null : t.id)}
              >
                {t.label}
                <small>{t.bpmRange[0]}-{t.bpmRange[1]} BPM</small>
              </button>
            ))}
          </div>
        </div>

        <div className="rule-group">
          <label>能量级别</label>
          <div className="rule-options">
            {ENERGY_LEVELS.map(e => (
              <button
                key={e.id}
                className={`rule-btn ${rules.energy === e.id ? 'active' : ''}`}
                onClick={() => updateRule('energy', rules.energy === e.id ? null : e.id)}
              >
                {e.label}
              </button>
            ))}
          </div>
        </div>

        <div className="rule-group">
          <label>可舞性</label>
          <div className="rule-options">
            {DANCEABILITY_LEVELS.map(d => (
              <button
                key={d.id}
                className={`rule-btn ${rules.danceability === d.id ? 'active' : ''}`}
                onClick={() => updateRule('danceability', rules.danceability === d.id ? null : d.id)}
              >
                {d.label}
              </button>
            ))}
          </div>
        </div>

        <div className="rule-group">
          <label>原声性</label>
          <div className="rule-options">
            {ACOUSTICNESS_LEVELS.map(a => (
              <button
                key={a.id}
                className={`rule-btn ${rules.acousticness === a.id ? 'active' : ''}`}
                onClick={() => updateRule('acousticness', rules.acousticness === a.id ? null : a.id)}
              >
                {a.label}
              </button>
            ))}
          </div>
        </div>

        <div className="rule-group">
          <label>人声风格</label>
          <div className="rule-options">
            {VOCAL_STYLES.map(v => (
              <button
                key={v.id}
                className={`rule-btn ${rules.vocalStyle === v.id ? 'active' : ''}`}
                onClick={() => updateRule('vocalStyle', rules.vocalStyle === v.id ? null : v.id)}
              >
                {v.label}
              </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
